"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import WaitingSpinner from "../../components/waiting_spinner";
import React from "react";
import { History } from "react-router";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import { startNewFlowSession, verifyNextItemOrGetNext, usedNextItem } from "./flow_mode_service";
import {
  carrierInvoiceWithLoadPath,
  documentBatchWithEmailPath,
  documentGroupPath,
  pathToEmail
} from "./dashboard_paths";
import LoadsService from "../loads_service";
import Api from "../../api/api";
const FlowModeFindNextItemPage = React.createClass({
  mixins: [History],
  propTypes: {
    location: React.PropTypes.object
  },
  getInitialState: function() {
    return {};
  },
  componentDidMount: function() {
    return __async(this, null, function* () {
      if (!this.props.location.query.started) {
        startNewFlowSession();
      }
      const result = yield verifyNextItemOrGetNext(this.props.location.query.queue, this.props.location.query);
      const options = yield this.buildOptions(result);
      this.setState({
        loaded: true,
        nextItem: result,
        itemOptions: options
      });
      this.goToNextBatchOrDashboard();
    });
  },
  buildOptions: function(result) {
    return __async(this, null, function* () {
      let options = {};
      const ltlReconcileEnabled = Api.Account.currentSettings().ltl_reconcile_enabled;
      const { loadStateId, invoiceId } = this.invoiceAndLoadStateIds(result);
      if (ltlReconcileEnabled && loadStateId && invoiceId) {
        const loadState = yield LoadsService.getLoad(loadStateId);
        if (loadState) {
          const invoice = loadState.carrier_invoices.find((ci) => ci.id.toString() === invoiceId);
          options["invoiceRequiresLtlReconciliation"] = (invoice == null ? void 0 : invoice.requires_ltl_reconciliation) || false;
        }
      }
      return options;
    });
  },
  content: function() {
    if (this.state.loaded) {
      return /* @__PURE__ */ React.createElement("div", null, "Redirecting to the next item");
    }
    return /* @__PURE__ */ React.createElement("div", null, "Loading");
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: !this.state.loaded }, this.content());
  },
  goToNextBatchOrDashboard() {
    const nextUrl = this.nextUrl();
    usedNextItem();
    if (nextUrl) {
      const url = nextUrl.pathString();
      let onDone = "/flow" + this.props.location.search;
      if (onDone.indexOf("&started=1") === -1) {
        onDone += "&started=1";
      }
      const query = __spreadProps(__spreadValues({}, nextUrl.queryObj()), {
        hasMore: false,
        onDone,
        filters: this.props.location.query.filters
      });
      console.log("Flow Mode: flowing to ", { url, query, time: /* @__PURE__ */ new Date() });
      this.history.replaceState(null, url, query);
    } else {
      const onDone = this.props.location.query.onDone || "/dashboard";
      console.log("Flow Mode: flowing to dashboard due to not finding next item", { onDone, time: /* @__PURE__ */ new Date() });
      ToDashboardWithFilters(this.props.location, this.history, onDone);
    }
  },
  nextUrl() {
    if (!this.state.nextItem) {
      return null;
    }
    const urlBuilder = {
      "new": this.nextUrlForEmail,
      "indexing": this.nextUrlForIndexEmail,
      "ready-to-audit": this.nextUrlForCarrierInvoice,
      "replies": this.nextUrlForEmail,
      "exceptions": this.nextUrlForExceptionedItem,
      "waiting": this.nextUrlForExceptionedItem
    }[this.props.location.query.queue];
    if (urlBuilder) {
      return urlBuilder.apply(this);
    } else {
      return null;
    }
  },
  nextUrlForEmail() {
    const ctx = this.state.nextItem.full_id_context;
    return pathToEmail({
      emailMessageId: ctx.emailId,
      maybeDocumentBatchId: ctx.batchId,
      maybeEmailType: ctx.emailType,
      hasSubmission: ctx.hasSubmission,
      maybeInvoiceOwnerParams: ctx.ownerFactorInvoiceId ? {
        kind: "factor",
        factorInvoiceId: ctx.ownerFactorInvoiceId
      } : ctx.ownerCarrierInvoiceId ? {
        kind: "carrier",
        loadStateId: ctx.ownerCarrierInvoiceLoadStateId,
        carrierInvoice: {
          invoiceId: ctx.ownerCarrierInvoiceId,
          requiresLtlReconciliation: this.invoiceRequiresLtlReconciliation()
        }
      } : null,
      maybeConformingSubmission: ctx.conformingSubmissionLoadStateId ? {
        loadStateId: ctx.conformingSubmissionLoadStateId,
        carrierInvoice: {
          invoiceId: ctx.conformingSubmissionCarrierInvoiceId,
          requiresLtlReconciliation: this.invoiceRequiresLtlReconciliation()
        }
      } : null
    });
  },
  invoiceAndLoadStateIds: function(result) {
    let ids = { loadStateId: null, invoiceId: null };
    const id_context = result == null ? void 0 : result.full_id_context;
    if (id_context == null ? void 0 : id_context.loadStateId) {
      ids.loadStateId = id_context.loadStateId;
      ids.invoiceId = id_context == null ? void 0 : id_context.invoiceId;
    } else if (id_context == null ? void 0 : id_context.ownerCarrierInvoiceLoadStateId) {
      ids.loadStateId = id_context.ownerCarrierInvoiceLoadStateId;
      ids.invoiceId = id_context == null ? void 0 : id_context.ownerCarrierInvoiceId;
    } else if (id_context == null ? void 0 : id_context.conformingSubmissionLoadStateId) {
      ids.loadStateId = id_context.conformingSubmissionLoadStateId;
      ids.invoiceId = id_context == null ? void 0 : id_context.conformingSubmissionCarrierInvoiceId;
    }
    return ids;
  },
  invoiceRequiresLtlReconciliation() {
    var _a;
    return ((_a = this.state.itemOptions) == null ? void 0 : _a.invoiceRequiresLtlReconciliation) || false;
  },
  nextUrlForIndexEmail() {
    const ctx = this.state.nextItem.full_id_context;
    return documentBatchWithEmailPath(ctx.batchId, ctx.emailId);
  },
  nextUrlForCarrierInvoice() {
    const ctx = this.state.nextItem.full_id_context;
    return carrierInvoiceWithLoadPath(ctx.loadStateId, ctx.invoiceId, this.invoiceRequiresLtlReconciliation());
  },
  nextUrlForExceptionedItem() {
    const ctx = this.state.nextItem.full_id_context;
    if (ctx.ownerCarrierInvoiceId) {
      return carrierInvoiceWithLoadPath(ctx.ownerCarrierInvoiceLoadStateId, ctx.ownerCarrierInvoiceId, this.invoiceRequiresLtlReconciliation());
    } else {
      return documentGroupPath(ctx.ownerDocumentGroupDocumentBatchId, ctx.ownerDocumentGroupId);
    }
  }
});
export default FlowModeFindNextItemPage;
